module.exports = __webpack_public_path__ + "static/media/reloadIcon.2c3b1d3e.svg";